import { getHostName, convertToUTC } from "../utils";
import { cachedGet } from "./requestCache.js";

export async function fetchStages(query, filters, family, type) {
  const jsonString = encodeURIComponent(JSON.stringify(filters));
  const key = `stages:${family}:${type}:${query}:${jsonString}`;

  return cachedGet(key, async () => {
    const data = await fetch(
      `${getHostName()}/api/stages/?format=json&filter=${jsonString}&query=${query}&family=${family}&type=${type}`
    );
    if (!data.ok) {
      throw new Error("Stages Not Found");
    }
    return data.json();
  });
}

export async function fetchStageInfo(id, startDate) {
  const dateKey = startDate ? convertToUTC(startDate) : "";
  const key = `stageinfo:${id}:${dateKey}`;

  return cachedGet(key, async () => {
    const data = await fetch(
      `${getHostName()}/api/stageinformation/?id=${id}${dateKey ? `&startdate=${dateKey}` : ""}&format=json`
    );
    if (!data.ok) {
      throw new Error("Stage Not Found");
    }
    return data.json();
  });
}
